export class OrderM{
  id:number = 0;
  no:string = '';
  student_id:number = 0;
  teacher_id:number = 0;
  price_total:number = 0;
  qty_total:number = 0;
  discount:number = 0;
  price_net:number = 0;
  firstname:string = '';
  lastname:string = '';
  email:string = '';
  phone:string = '';
  created_at:string = '';
  updated_at:string = '';
}



// WEBPACK FOOTER //
// ./src/app/model/order.mobel.ts